import { createAsyncThunk } from '@reduxjs/toolkit';

import { get } from './http';
import { activeSnack } from '../store/common';

// state

export const getAllState = createAsyncThunk('/state/list', async ({ dispatch }) => {
  try {
    const URL = `/state/all/`;
    const response = await get(URL);
    if (response) {
      // navigate('/home');
      return response;
    }
    return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
  } catch (error) {
    dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
    throw error?.response?.data?.message;
  }
});
// district
export const getAllDistrict = createAsyncThunk('/district/list', async ({ stateId, dispatch }) => {
  try {
    const URL = `/district/all?state=${stateId || '65719111257678ac26a84762'}`;
    const response = await get(URL);
    if (response) {
      // navigate('/home');
      // dispatch(activeSnack({ type: 'success', message: 'Review Submitted Successfully' }));
      return response;
    }
    return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
  } catch (error) {
    dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
    throw error?.response?.data?.message;
  }
});
